import { lang } from '@umu/ukit-lang';
import { PRACTICE_TYPE } from '@umu/umu-types';

export const practiceTypeName: Record<PRACTICE_TYPE, string> = {
    [PRACTICE_TYPE.HOMEWORK_VIDEO]: lang('视频练习'),
    [PRACTICE_TYPE.EXAM]: lang('考试'),
    [PRACTICE_TYPE.CHATBOT]: lang('Chatbot'),
};
